import { render } from "./DefaultPanelSelectedTests.vue?vue&type=template&id=0387d413"
import script from "./DefaultPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./DefaultPanelSelectedTests.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sendOuts/testInfo/selectedTestsPreview/DefaultPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0387d413"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0387d413', __exports__)) {
    console.log('reload')
    api.reload('0387d413', __exports__)
  }
  
  module.hot.accept("./DefaultPanelSelectedTests.vue?vue&type=template&id=0387d413", () => {
    console.log('re-render')
    api.rerender('0387d413', render)
  })

}


export default __exports__